// @ts-nocheck
import './styles.css';

// Configuration
const CONFIG = {
    MAX_TAB_NAME: 20,
    MAX_BOX_NAME: 20,
    MAX_NOTE_CHARS: 2000,
    STORAGE_KEY: 'tempsticky',
    EXPORT_FILENAME: 'tempsticky.json',
    VERSION: '1.1.0',
    TAB_SWITCH_HOLD_MS: 1000,
    NOTE_WIDTH: 200,
    NOTE_MIN_HEIGHT: 60
};

// Predefined colors for tabs (first color is the default for new tabs)
const TAB_COLORS = [
    '#6b6b6b', '#5b6abf', '#bf5b5b', '#5bbf5b', '#bf9f5b',
    '#5bbfbf', '#9f5bbf', '#bf5b9f', '#7a8f5b', '#5b7abf',
    '#bf7a5b', '#6b9f6b', '#9f6b9f', '#6b9fbf', '#bf6b8f',
    '#8fbf6b', '#6b6bbf', '#bf8f6b', '#6bbf8f', '#8f6bbf'
];

// Predefined colors for notes
const NOTE_COLORS = [
    '#9a9aaa', '#a8b8d8', '#d8a8a8', '#a8d8a8', '#d8d0a8',
    '#c8a8d8', '#a8d8d0', '#d8b8a8', '#b0b8c8', '#c8c0a8'
];

// Default box colors for layouts
const BOX_COLORS = [
    'rgba(60, 60, 90, 0.35)', 'rgba(70, 50, 50, 0.35)',
    'rgba(50, 70, 50, 0.35)', 'rgba(70, 70, 50, 0.35)',
    'rgba(50, 60, 70, 0.35)', 'rgba(60, 50, 70, 0.35)',
    'rgba(70, 60, 50, 0.35)'
];

// Layout definitions
const LAYOUTS = {
    empty: { boxes: [] },
    'three-column': {
        boxes: [
            { name: 'Left', color: BOX_COLORS[ 0 ] },
            { name: 'Center', color: BOX_COLORS[ 1 ] },
            { name: 'Right', color: BOX_COLORS[ 2 ] }
        ]
    },
    'four-column': {
        boxes: [
            { name: 'Column 1', color: BOX_COLORS[ 0 ] },
            { name: 'Column 2', color: BOX_COLORS[ 1 ] },
            { name: 'Column 3', color: BOX_COLORS[ 2 ] },
            { name: 'Column 4', color: BOX_COLORS[ 3 ] }
        ]
    },
    'two-split': {
        boxes: [
            { name: 'Left', color: BOX_COLORS[ 0 ] },
            { name: 'Right', color: BOX_COLORS[ 1 ] }
        ]
    },
    'three-split': {
        boxes: [
            { name: 'Top Left', color: BOX_COLORS[ 0 ] },
            { name: 'Top Right', color: BOX_COLORS[ 1 ] },
            { name: 'Bottom', color: BOX_COLORS[ 2 ] }
        ]
    },
    'four-split': {
        boxes: [
            { name: 'Top Left', color: BOX_COLORS[ 0 ] },
            { name: 'Top Right', color: BOX_COLORS[ 1 ] },
            { name: 'Bottom Left', color: BOX_COLORS[ 2 ] },
            { name: 'Bottom Right', color: BOX_COLORS[ 3 ] }
        ]
    },
    kanban: {
        boxes: [
            { name: 'Backlog', color: BOX_COLORS[ 0 ] },
            { name: 'To Do', color: BOX_COLORS[ 1 ] },
            { name: 'In Progress', color: BOX_COLORS[ 2 ] },
            { name: 'Done', color: BOX_COLORS[ 3 ] }
        ]
    },
    weekday: {
        boxes: [
            { name: 'Monday', color: BOX_COLORS[ 0 ] },
            { name: 'Tuesday', color: BOX_COLORS[ 1 ] },
            { name: 'Wednesday', color: BOX_COLORS[ 2 ] },
            { name: 'Thursday', color: BOX_COLORS[ 3 ] },
            { name: 'Friday', color: BOX_COLORS[ 4 ] },
            { name: 'Saturday', color: BOX_COLORS[ 5 ] },
            { name: 'Sunday', color: BOX_COLORS[ 6 ] }
        ]
    }
};

// ---- State ----
let state = null;
let activeTabId = null;
let dragState = null;
let selectionState = null;
let tabSettingsBackup = null;
let modalDragState = null;

// ---- DOM References ----
const dom = {};

// ---- Initialization ----
document.addEventListener( 'DOMContentLoaded', init );

function init() {
    cacheDom();
    loadState();
    applyTheme();
    applyLanguage();
    renderTabs();
    switchToTab( activeTabId || state.tabs[ 0 ].id );
    bindEvents();
    dom.menuVersion.textContent = 'v' + CONFIG.VERSION;
    cleanRecycleBin();
}

function cacheDom() {
    dom.header = document.getElementById( 'header' );
    dom.hamburgerBtn = document.getElementById( 'hamburgerBtn' );
    dom.hamburgerMenu = document.getElementById( 'hamburgerMenu' );
    dom.tabBar = document.getElementById( 'tabBar' );
    dom.canvas = document.getElementById( 'canvas' );
    dom.modalOverlay = document.getElementById( 'modalOverlay' );
    dom.howToModal = document.getElementById( 'howToModal' );
    dom.tabSettingsModal = document.getElementById( 'tabSettingsModal' );
    dom.appSettingsModal = document.getElementById( 'appSettingsModal' );
    dom.confirmDialog = document.getElementById( 'confirmDialog' );
    dom.tabNameInput = document.getElementById( 'tabNameInput' );
    dom.tabColorPicker = document.getElementById( 'tabColorPicker' );
    dom.tabLayoutSelect = document.getElementById( 'tabLayoutSelect' );
    dom.layoutBoxSettings = document.getElementById( 'layoutBoxSettings' );
    dom.tabSettingsSave = document.getElementById( 'tabSettingsSave' );
    dom.tabSettingsCancel = document.getElementById( 'tabSettingsCancel' );
    dom.tabSettingsDelete = document.getElementById( 'tabSettingsDelete' );
    dom.themeBtns = document.querySelectorAll( '.theme-btn' );
    dom.langBtns = document.querySelectorAll( '.lang-btn' );
    dom.menuVersion = document.getElementById( 'menuVersion' );
    dom.notification = document.getElementById( 'notification' );
    dom.importFileInput = document.getElementById( 'importFileInput' );
    dom.instantDeleteCheck = document.getElementById( 'instantDeleteCheck' );
    dom.autoDeleteCheck = document.getElementById( 'autoDeleteCheck' );
    dom.autoDeleteDays = document.getElementById( 'autoDeleteDays' );
    dom.appSettingsSave = document.getElementById( 'appSettingsSave' );
    dom.appSettingsCancel = document.getElementById( 'appSettingsCancel' );
    dom.confirmTitle = document.getElementById( 'confirmTitle' );
    dom.confirmMessage = document.getElementById( 'confirmMessage' );
    dom.confirmYes = document.getElementById( 'confirmYes' );
    dom.confirmNo = document.getElementById( 'confirmNo' );
}

// ---- State Management ----

function createDefaultWelcomeNotes( language ) {
    const selectedLanguage = language || ( state && state.settings && state.settings.language ) || detectBrowserLanguage();
    const noteSpecs = [
        {
            content: translateForLanguage( 'welcome_note_storage', selectedLanguage ),
            color: NOTE_COLORS[ 2 ],
            estimatedHeightPx: 130
        },
        {
            content: translateForLanguage( 'welcome_note_edit', selectedLanguage ),
            color: NOTE_COLORS[ 1 ],
            estimatedHeightPx: 88
        },
        {
            content: translateForLanguage( 'welcome_note_drag', selectedLanguage ),
            color: NOTE_COLORS[ 3 ],
            estimatedHeightPx: 88
        },
        {
            content: translateForLanguage( 'welcome_note_create', selectedLanguage ),
            color: NOTE_COLORS[ 0 ],
            estimatedHeightPx: 70
        },
        {
            content: translateForLanguage( 'welcome_note_tab_settings', selectedLanguage ),
            color: NOTE_COLORS[ 4 ],
            estimatedHeightPx: 88
        }
    ];

    const viewportWidth = Math.max( window.innerWidth || 1280, 320 );
    const viewportHeight = Math.max( window.innerHeight || 720, 480 );
    const isMobile = viewportWidth < 700;

    const anchors = isMobile ?
        [ [ 4, 4 ], [ 6, 24 ], [ 5, 44 ], [ 7, 64 ], [ 6, 84 ] ] :
        [ [ 4, 4 ], [ 36, 4 ], [ 68, 4 ], [ 20, 42 ], [ 52, 42 ] ];

    const placed = [];
    const notes = [];
    const noteWidthPct = ( CONFIG.NOTE_WIDTH / viewportWidth ) * 100;

    noteSpecs.forEach( ( spec, i ) => {
        const anchor = anchors[ i ] || [ 4 + i * 4, 4 + i * 8 ];
        const noteHeightPct = ( spec.estimatedHeightPx / viewportHeight ) * 100;
        const maxX = Math.max( 1, 100 - noteWidthPct - 1 );
        const maxY = Math.max( 1, 100 - noteHeightPct - 1 );
        let placedPos = null;

        for ( let attempt = 0; attempt < 10; attempt++ ) {
            const jitterX = Math.floor( Math.random() * 5 ) - 2;
            const jitterY = Math.floor( Math.random() * 5 ) - 2;
            const x = Math.max( 1, Math.min( maxX, anchor[ 0 ] + jitterX ) );
            const y = Math.max( 1, Math.min( maxY, anchor[ 1 ] + jitterY ) );
            const candidate = {
                x: x,
                y: y,
                width: noteWidthPct,
                height: noteHeightPct
            };

            const overlaps = placed.some( p => {
                return candidate.x < p.x + p.width &&
                    candidate.x + candidate.width > p.x &&
                    candidate.y < p.y + p.height &&
                    candidate.y + candidate.height > p.y;
            } );

            if ( ! overlaps ) {
                placedPos = candidate;
                break;
            }
        }

        if ( ! placedPos ) {
            placedPos = {
                x: Math.max( 1, Math.min( maxX, anchor[ 0 ] ) ),
                y: Math.max( 1, Math.min( maxY, anchor[ 1 ] ) ),
                width: noteWidthPct,
                height: noteHeightPct
            };
        }

        placed.push( placedPos );
        notes.push( createNote( spec.content, placedPos.x, placedPos.y, spec.color ) );
    } );

    return notes;
}

function getDefaultState() {
    const detectedLanguage = detectBrowserLanguage();
    const welcomeTab = createTab( translateForLanguage( 'tab_welcome_name', detectedLanguage ), TAB_COLORS[ 0 ], 'empty' );
    welcomeTab.notes = createDefaultWelcomeNotes( detectedLanguage );
    const recycleBin = createRecycleBinTab();
    return {
        settings: {
            language: detectedLanguage,
            themeMode: 'system',
            recycleBin: {
                autoDelete: false,
                autoDeleteDays: 30,
                instantDelete: false
            }
        },
        tabs: [ welcomeTab, recycleBin ],
        activeTabId: welcomeTab.id
    };
}

function loadState() {
    try {
        const raw = localStorage.getItem( CONFIG.STORAGE_KEY );
        if ( raw ) {
            state = JSON.parse( raw );
            if ( ! state.settings ) state.settings = {};
            if ( ! state.settings.language ) state.settings.language = 'en';
            if ( ! SUPPORTED_LANGUAGES.includes( state.settings.language ) ) state.settings.language = 'en';
            // Ensure recycle bin tab exists
            if ( ! state.tabs.find( t => t.isRecycleBin ) ) {
                state.tabs.push( createRecycleBinTab() );
            }
            activeTabId = state.activeTabId || state.tabs[ 0 ].id;
            migratePixelPositions();
        } else {
            state = getDefaultState();
            activeTabId = state.activeTabId;
            saveState();
        }
    } catch ( e ) {
        state = getDefaultState();
        activeTabId = state.activeTabId;
        saveState();
    }
}

function migratePixelPositions() {
    // Migrate old pixel-based positions (> 100) to percentages.
    // Percentage values are 0-100, pixel values are typically > 100 for any
    // note placed beyond the first ~1% of the canvas.
    let migrated = false;
    const refWidth = 1280;
    const refHeight = 660;
    state.tabs.forEach( tab => {
        tab.notes.forEach( note => {
            if ( note.x > 100 || note.y > 100 ) {
                note.x = Math.min( 95, ( note.x / refWidth ) * 100 );
                note.y = Math.min( 95, ( note.y / refHeight ) * 100 );
                migrated = true;
            }
        } );
    } );
    if ( migrated ) saveState();
}

function saveState() {
    state.activeTabId = activeTabId;
    localStorage.setItem( CONFIG.STORAGE_KEY, JSON.stringify( state ) );
}

function createId() {
    return Date.now().toString( 36 ) + Math.random().toString( 36 ).slice( 2, 9 );
}

function createTab( name, color, layout ) {
    const selectedLayout = layout || 'empty';
    const language = ( state && state.settings && state.settings.language ) || detectBrowserLanguage();
    return {
        id: createId(),
        name: name,
        color: color || TAB_COLORS[ 0 ],
        layout: selectedLayout,
        isRecycleBin: false,
        boxes: getLocalizedLayoutBoxes( selectedLayout, language ),
        notes: []
    };
}

function createRecycleBinTab() {
    return {
        id: createId(),
        name: '',
        color: '#555566',
        layout: 'empty',
        isRecycleBin: true,
        boxes: [],
        notes: []
    };
}

function createNote( content, x, y, color ) {
    return {
        id: createId(),
        content: content || '',
        color: color || NOTE_COLORS[ 0 ],
        x: x || 10,
        y: y || 10,
        boxIndex: -1,
        recycledAt: null
    };
}

function getLocalizedLayoutBoxes( layout, language ) {
    const lang = SUPPORTED_LANGUAGES.includes( language ) ? language : 'en';
    const layoutDef = LAYOUTS[ layout ] || LAYOUTS.empty;
    const namesByLayout = {
        'three-column': [ 'layout_box_left', 'layout_box_center', 'layout_box_right' ],
        'four-column': [ 'layout_box_column_1', 'layout_box_column_2', 'layout_box_column_3', 'layout_box_column_4' ],
        'two-split': [ 'layout_box_left', 'layout_box_right' ],
        'three-split': [ 'layout_box_top_left', 'layout_box_top_right', 'layout_box_bottom' ],
        'four-split': [ 'layout_box_top_left', 'layout_box_top_right', 'layout_box_bottom_left', 'layout_box_bottom_right' ],
        kanban: [ 'layout_box_backlog', 'layout_box_todo', 'layout_box_in_progress', 'layout_box_done' ],
        weekday: [ 'layout_box_monday', 'layout_box_tuesday', 'layout_box_wednesday', 'layout_box_thursday', 'layout_box_friday', 'layout_box_saturday', 'layout_box_sunday' ]
    };
    const nameKeys = namesByLayout[ layout ] || [];
    return layoutDef.boxes.map( ( b, i ) => ( {
        name: nameKeys[ i ] ? translateForLanguage( nameKeys[ i ], lang ) : b.name,
        color: b.color
    } ) );
}

function getActiveTab() {
    return state.tabs.find( t => t.id === activeTabId );
}

function getTabById( id ) {
    return state.tabs.find( t => t.id === id );
}

function createTrashIconSvg( size ) {
    const ns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS( ns, 'svg' );
    const iconSize = size || 18;
    svg.setAttribute( 'width', String( iconSize ) );
    svg.setAttribute( 'height', String( iconSize ) );
    svg.setAttribute( 'viewBox', '0 0 24 24' );
    svg.setAttribute( 'fill', 'none' );
    svg.setAttribute( 'aria-hidden', 'true' );

    const body = document.createElementNS( ns, 'path' );
    body.setAttribute( 'fill-rule', 'evenodd' );
    body.setAttribute( 'clip-rule', 'evenodd' );
    body.setAttribute( 'd', 'M17 5V4C17 2.89543 16.1046 2 15 2H9C7.89543 2 7 2.89543 7 4V5H4C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7H5V18C5 19.6569 6.34315 21 8 21H16C17.6569 21 19 19.6569 19 18V7H20C20.5523 7 21 6.55228 21 6C21 5.44772 20.5523 5 20 5H17ZM15 4H9V5H15V4ZM17 7H7V18C7 18.5523 7.44772 19 8 19H16C16.5523 19 17 18.5523 17 18V7Z' );
    body.setAttribute( 'fill', 'currentColor' );

    const bar1 = document.createElementNS( ns, 'path' );
    bar1.setAttribute( 'd', 'M9 9H11V17H9V9Z' );
    bar1.setAttribute( 'fill', 'currentColor' );

    const bar2 = document.createElementNS( ns, 'path' );
    bar2.setAttribute( 'd', 'M13 9H15V17H13V9Z' );
    bar2.setAttribute( 'fill', 'currentColor' );

    svg.appendChild( body );
    svg.appendChild( bar1 );
    svg.appendChild( bar2 );
    return svg;
}

// ---- Theme ----

function getEffectiveTheme() {
    const mode = state.settings.themeMode || 'system';
    if ( mode === 'system' ) {
        return window.matchMedia( '(prefers-color-scheme: dark)' ).matches ? 'dark' : 'light';
    }
    return mode;
}

function applyTheme() {
    // Migrate old darkMode boolean to new themeMode string
    if ( state.settings.darkMode !== undefined && state.settings.themeMode === undefined ) {
        state.settings.themeMode = state.settings.darkMode ? 'dark' : 'light';
        delete state.settings.darkMode;
    }

    const effective = getEffectiveTheme();
    document.documentElement.setAttribute( 'data-theme', effective );

    // Update button active states
    const mode = state.settings.themeMode || 'system';
    dom.themeBtns.forEach( btn => {
        btn.classList.toggle( 'active', btn.dataset.themeMode === mode );
    } );
}

function detectBrowserLanguage() {
    const browserLang = ( navigator.language || 'en' ).toLowerCase();
    return browserLang.startsWith( 'de' ) ? 'de' : 'en';
}

function getCurrentLanguage() {
    return ( state && state.settings && state.settings.language ) || 'en';
}

function translateForLanguage( key, language, vars ) {
    const table = TRANSLATIONS[ key ];
    if ( ! table ) return key;
    const lang = SUPPORTED_LANGUAGES.includes( language ) ? language : 'en';
    let text = table[ lang ] || table.en || key;
    if ( vars ) {
        text = text.replace( /\{(\w+)\}/g, ( _, name ) => {
            return Object.prototype.hasOwnProperty.call( vars, name ) ? String( vars[ name ] ) : '';
        } );
    }
    return text;
}

function t( key, vars ) {
    return translateForLanguage( key, getCurrentLanguage(), vars );
}

function setText( id, key, vars ) {
    const el = document.getElementById( id );
    if ( el ) el.textContent = t( key, vars );
}

function setHtml( id, key, vars ) {
    const el = document.getElementById( id );
    if ( el ) el.innerHTML = t( key, vars );
}

function localizeSystemContentInState() {
    if ( ! state || ! Array.isArray( state.tabs ) ) return;
    const welcomeKeys = [
        'welcome_note_storage',
        'welcome_note_edit',
        'welcome_note_drag',
        'welcome_note_create',
        'welcome_note_tab_settings'
    ];

    state.tabs.forEach( tab => {
        if ( ! tab.isRecycleBin && Object.values( TRANSLATIONS.tab_welcome_name || {} ).includes( tab.name ) ) {
            tab.name = t( 'tab_welcome_name' );
        }
        tab.notes.forEach( note => {
            welcomeKeys.forEach( key => {
                const variants = Object.values( TRANSLATIONS[ key ] || {} );
                if ( variants.includes( note.content ) ) {
                    note.content = t( key );
                }
            } );
        } );
    } );
}

function applyLanguage() {
    const lang = getCurrentLanguage();
    document.documentElement.setAttribute( 'lang', lang );
    localizeSystemContentInState();

    dom.langBtns.forEach( btn => {
        btn.classList.toggle( 'active', btn.dataset.language === lang );
    } );

    dom.themeBtns.forEach( btn => {
        if ( btn.dataset.themeMode === 'light' ) btn.title = t( 'theme_light_title' );
        if ( btn.dataset.themeMode === 'system' ) btn.title = t( 'theme_system_title' );
        if ( btn.dataset.themeMode === 'dark' ) btn.title = t( 'theme_dark_title' );
    } );
    dom.langBtns.forEach( btn => {
        if ( btn.dataset.language === 'en' ) btn.title = t( 'language_en_title' );
        if ( btn.dataset.language === 'de' ) btn.title = t( 'language_de_title' );
    } );

    setText( 'menuHowTo', 'menu_how_to' );
    setText( 'menuImport', 'menu_import' );
    setText( 'menuExport', 'menu_export' );
    setText( 'menuDeleteAllNotes', 'menu_delete_all_notes' );
    setText( 'menuAppSettings', 'menu_app_settings' );
    setText( 'menuResetApp', 'menu_reset_app' );

    setText( 'howToModalTitle', 'menu_how_to' );
    setText( 'howToNotesTitle', 'howto_notes_title' );
    setHtml( 'howToNoteCreate', 'howto_note_create' );
    setHtml( 'howToNoteEdit', 'howto_note_edit' );
    setHtml( 'howToNoteMove', 'howto_note_move' );
    setHtml( 'howToNoteColor', 'howto_note_color' );
    setHtml( 'howToNoteDelete', 'howto_note_delete' );
    setHtml( 'howToNoteSelect', 'howto_note_select' );
    setText( 'howToTabsTitle', 'howto_tabs_title' );
    setHtml( 'howToTabSwitch', 'howto_tab_switch' );
    setHtml( 'howToTabNew', 'howto_tab_new' );
    setHtml( 'howToTabEdit', 'howto_tab_edit' );
    setHtml( 'howToTabMove', 'howto_tab_move' );
    setText( 'howToLayoutsTitle', 'howto_layouts_title' );
    setHtml( 'howToLayoutEmpty', 'howto_layout_empty' );
    setHtml( 'howToLayoutThreeColumn', 'howto_layout_three_column' );
    setHtml( 'howToLayoutFourColumn', 'howto_layout_four_column' );
    setHtml( 'howToLayoutTwoSplit', 'howto_layout_two_split' );
    setHtml( 'howToLayoutThreeSplit', 'howto_layout_three_split' );
    setHtml( 'howToLayoutFourSplit', 'howto_layout_four_split' );
    setHtml( 'howToLayoutKanban', 'howto_layout_kanban' );
    setHtml( 'howToLayoutWeekday', 'howto_layout_weekday' );
    setText( 'howToGeneralTitle', 'howto_general_title' );
    setHtml( 'howToGeneralImport', 'howto_general_import' );
    setHtml( 'howToGeneralTheme', 'howto_general_theme' );
    setHtml( 'howToGeneralRecycle', 'howto_general_recycle' );

    setText( 'tabSettingsTitle', 'tab_settings_title' );
    setText( 'tabNameLabel', 'tab_name_label' );
    if ( dom.tabNameInput ) dom.tabNameInput.placeholder = t( 'tab_name_placeholder' );
    setText( 'tabColorLabel', 'tab_color_label' );
    setText( 'tabLayoutLabel', 'tab_layout_label' );
    setText( 'layoutOptionEmpty', 'layout_option_empty' );
    setText( 'layoutOptionThreeColumn', 'layout_option_three_column' );
    setText( 'layoutOptionFourColumn', 'layout_option_four_column' );
    setText( 'layoutOptionTwoSplit', 'layout_option_two_split' );
    setText( 'layoutOptionThreeSplit', 'layout_option_three_split' );
    setText( 'layoutOptionFourSplit', 'layout_option_four_split' );
    setText( 'layoutOptionKanban', 'layout_option_kanban' );
    setText( 'layoutOptionWeekday', 'layout_option_weekday' );
    setText( 'tabSettingsSave', 'common_save' );
    setText( 'tabSettingsCancel', 'common_cancel' );
    setText( 'tabSettingsDelete', 'tab_delete_tab' );

    setText( 'appSettingsTitle', 'app_settings_title' );
    setText( 'recycleBinTitle', 'recycle_bin_title' );
    setText( 'instantDeleteLabel', 'app_instant_delete' );
    setText( 'autoDeleteLabel', 'app_auto_delete' );
    setText( 'autoDeleteDaysLabel', 'app_auto_delete_days' );
    setText( 'appSettingsSave', 'common_save' );
    setText( 'appSettingsCancel', 'common_cancel' );

    setText( 'confirmTitle', 'confirm_default_title' );
    setText( 'confirmYes', 'confirm_yes_delete' );
    setText( 'confirmNo', 'common_cancel' );

    if ( dom.tabSettingsModal && ! dom.tabSettingsModal.classList.contains( 'hidden' ) ) {
        const tab = getActiveTab();
        if ( tab && ! tab.isRecycleBin ) {
            renderLayoutBoxSettings( tab );
        }
    }
}

function setLanguage( language ) {
    const lang = SUPPORTED_LANGUAGES.includes( language ) ? language : 'en';
    if ( ! state.settings ) state.settings = {};
    if ( state.settings.language === lang ) return;
    state.settings.language = lang;
    applyLanguage();
    renderTabs();
    renderCanvas();
    saveState();
}

// ---- Rendering ----

function renderTabs() {
    dom.tabBar.innerHTML = '';
    const regularTabs = state.tabs.filter( t => ! t.isRecycleBin );
    const recycleBin = state.tabs.find( t => t.isRecycleBin );

    regularTabs.forEach( tab => {
        const el = document.createElement( 'button' );
        el.className = 'tab' + ( tab.id === activeTabId ? ' active' : '' );
        el.dataset.tabId = tab.id;
        el.style.background = tab.color;
        el.textContent = tab.name || '\u00A0';
        el.title = tab.name;
        dom.tabBar.appendChild( el );
    } );

    // Add tab button
    const addBtn = document.createElement( 'button' );
    addBtn.className = 'tab tab-add';
    addBtn.id = 'addTabBtn';
    addBtn.textContent = '+';
    addBtn.title = t( 'tab_new_title' );
    dom.tabBar.appendChild( addBtn );

    // Recycle bin tab
    if ( recycleBin ) {
        const rb = document.createElement( 'button' );
        rb.className = 'tab tab-recycle' + ( recycleBin.id === activeTabId ? ' active' : '' );
        rb.dataset.tabId = recycleBin.id;
        rb.appendChild( createTrashIconSvg( 18 ) );
        rb.title = t( 'recycle_bin_title' );
        dom.tabBar.appendChild( rb );
    }
}

function renderCanvas() {
    const tab = getActiveTab();
    if ( ! tab ) return;

    dom.canvas.innerHTML = '';

    if ( tab.isRecycleBin ) {
        renderRecycleBin( tab );
        return;
    }

    if ( tab.layout !== 'empty' && tab.boxes.length > 0 ) {
        renderLayoutCanvas( tab );
    } else {
        renderFreeCanvas( tab );
    }
}

function renderFreeCanvas( tab ) {
    tab.notes.forEach( note => {
        const el = createNoteElement( note );
        dom.canvas.appendChild( el );
    } );
    applyNoteStackingOrder( tab );
}

function renderLayoutCanvas( tab ) {
    const container = document.createElement( 'div' );
    const splitLayoutClass = tab.layout === 'three-split' || tab.layout === 'four-split' ? ( ' ' + tab.layout ) : '';
    container.className = 'layout-container' + splitLayoutClass;

    tab.boxes.forEach( ( box, i ) => {
        const boxEl = document.createElement( 'div' );
        boxEl.className = 'layout-box';
        boxEl.dataset.boxIndex = i;
        boxEl.style.background = box.color || 'transparent';

        const headerEl = document.createElement( 'div' );
        headerEl.className = 'layout-box-header';
        headerEl.textContent = box.name || '\u00A0';
        boxEl.appendChild( headerEl );

        container.appendChild( boxEl );
    } );

    dom.canvas.appendChild( container );

    // Assign unassigned notes to first box
    tab.notes.filter( n => n.boxIndex === -1 || n.boxIndex >= tab.boxes.length ).forEach( note => {
        note.boxIndex = 0;
    } );

    // Render all notes directly on the canvas (above the layout container)
    tab.notes.forEach( note => {
        const el = createNoteElement( note );
        dom.canvas.appendChild( el );
    } );
    applyNoteStackingOrder( tab );
}

function renderRecycleBin( tab ) {
    const container = document.createElement( 'div' );
    container.className = 'recycle-container';

    // Sort notes by recycledAt, newest first
    const sorted = [ ...tab.notes ].sort( ( a, b ) => ( b.recycledAt || 0 ) - ( a.recycledAt || 0 ) );

    sorted.forEach( note => {
        const el = document.createElement( 'div' );
        el.className = 'note';
        el.dataset.noteId = note.id;
        el.style.background = note.color;

        const content = document.createElement( 'div' );
        content.className = 'note-content';
        content.textContent = note.content;
        el.appendChild( content );

        container.appendChild( el );
    } );

    dom.canvas.appendChild( container );
}

function createNoteElement( note ) {
    const el = document.createElement( 'div' );
    el.className = 'note';
    el.dataset.noteId = note.id;
    el.style.background = note.color;
    el.style.left = note.x + '%';
    el.style.top = note.y + '%';

    // Content
    const contentEl = document.createElement( 'div' );
    contentEl.className = 'note-content';
    contentEl.textContent = note.content;
    el.appendChild( contentEl );

    // Color bar (visible in edit mode)
    const colorBar = document.createElement( 'div' );
    colorBar.className = 'note-color-bar';
    const swatchesWrap = document.createElement( 'div' );
    swatchesWrap.className = 'note-color-swatches';
    NOTE_COLORS.forEach( c => {
        const swatch = document.createElement( 'div' );
        swatch.className = 'note-color-swatch' + ( c === note.color ? ' active' : '' );
        swatch.style.background = c;
        swatch.dataset.color = c;
        swatchesWrap.appendChild( swatch );
    } );
    colorBar.appendChild( swatchesWrap );

    const deleteBtn = document.createElement( 'button' );
    deleteBtn.className = 'note-delete-btn';
    deleteBtn.type = 'button';
    deleteBtn.title = t( 'note_delete_button_title' );
    deleteBtn.setAttribute( 'aria-label', t( 'note_delete_button_title' ) );
    deleteBtn.appendChild( createTrashIconSvg( 20 ) );
    colorBar.appendChild( deleteBtn );

    el.appendChild( colorBar );

    return el;
}

function applyNoteStackingOrder( tab ) {
    if ( ! tab ) return;
    tab.notes.forEach( ( note, index ) => {
        const el = dom.canvas.querySelector( `[data-note-id="${ note.id }"]` );
        if ( el ) {
            el.style.zIndex = String( 10 + index );
        }
    } );
}

function bringNotesToFront( tab, noteIds, primaryNoteId ) {
    if ( ! tab || ! Array.isArray( noteIds ) || noteIds.length === 0 ) return;

    const ids = new Set( noteIds );
    const promoted = [];
    const remaining = [];

    tab.notes.forEach( note => {
        if ( ids.has( note.id ) ) {
            promoted.push( note );
        } else {
            remaining.push( note );
        }
    } );

    if ( promoted.length === 0 ) return;

    // Keep the main dragged note as the very topmost among promoted notes.
    if ( primaryNoteId && promoted.length > 1 ) {
        const primaryIndex = promoted.findIndex( note => note.id === primaryNoteId );
        if ( primaryIndex >= 0 ) {
            const primary = promoted.splice( primaryIndex, 1 )[ 0 ];
            promoted.push( primary );
        }
    }

    tab.notes = remaining.concat( promoted );
    applyNoteStackingOrder( tab );
}

// ---- Tab Management ----

function switchToTab( tabId ) {
    activeTabId = tabId;
    renderTabs();
    renderCanvas();
    saveState();
}

function addNewTab() {
    const regularTabs = state.tabs.filter( t => ! t.isRecycleBin );
    const name = String( regularTabs.length + 1 );
    const tab = createTab( name, TAB_COLORS[ 0 ], 'empty' );
    // Insert before recycle bin
    const rbIndex = state.tabs.findIndex( t => t.isRecycleBin );
    if ( rbIndex >= 0 ) {
        state.tabs.splice( rbIndex, 0, tab );
    } else {
        state.tabs.push( tab );
    }
    saveState();
    switchToTab( tab.id );
}

function promptDeleteTab() {
    const tab = getActiveTab();
    if ( ! tab || tab.isRecycleBin ) return;

    const noteCount = tab.notes.length;
    const instantDelete = state.settings.recycleBin.instantDelete;

    const title = t( 'confirm_delete_tab_title' );
    const message = instantDelete
        ? t( 'confirm_delete_tab_instant_message', { count: noteCount } )
        : t( 'confirm_delete_tab_recycle_message', { count: noteCount } );

    showConfirmDialog( title, message, () => {
        deleteTab( tab.id );
    } );
}

function deleteTab( tabId ) {
    const tab = getTabById( tabId );
    if ( ! tab || tab.isRecycleBin ) return;

    const regularTabsBefore = state.tabs.filter( t => ! t.isRecycleBin );
    const regularTabIndex = regularTabsBefore.indexOf( tab );

    if ( state.settings.recycleBin.instantDelete ) {
        // Permanently discard all notes on this tab
        tab.notes = [];
    } else {
        // Move all notes to the recycle bin
        const recycleBin = state.tabs.find( t => t.isRecycleBin );
        if ( recycleBin ) {
            tab.notes.forEach( note => {
                note.recycledAt = Date.now();
                note.boxIndex = -1;
                recycleBin.notes.push( note );
            } );
        }
        tab.notes = [];
    }

    // Remove the tab from state
    const tabIndex = state.tabs.indexOf( tab );
    state.tabs.splice( tabIndex, 1 );

    // Switch to an adjacent regular tab
    const regularTabsAfter = state.tabs.filter( t => ! t.isRecycleBin );
    if ( regularTabsAfter.length > 0 ) {
        const newIdx = Math.min( regularTabIndex, regularTabsAfter.length - 1 );
        activeTabId = regularTabsAfter[ newIdx ].id;
    } else {
        activeTabId = state.tabs[ 0 ].id;
    }

    lastAutoCreatedNoteId = null;
    saveState();
    hideModal( 'tabSettingsModal' );
    renderTabs();
    renderCanvas();
    showNotification( t( 'notification_tab_deleted' ) );
}

// ---- Note Management ----

// Track last auto-created note to remove if empty on next create
let lastAutoCreatedNoteId = null;

function getLiveNoteDraftContent( noteId ) {
    if ( ! dom.canvas ) return null;
    const noteEl = dom.canvas.querySelector( `[data-note-id="${ noteId }"]` );
    if ( ! noteEl || ! noteEl.classList.contains( 'editing' ) ) return null;
    const textarea = noteEl.querySelector( 'textarea' );
    return textarea ? textarea.value : null;
}

function addNewNote( x, y, boxIndex ) {
    const tab = getActiveTab();
    if ( ! tab || tab.isRecycleBin ) return;

    // Remove previous auto-created note if it has no content and default color
    if ( lastAutoCreatedNoteId ) {
        const prevNote = tab.notes.find( n => n.id === lastAutoCreatedNoteId );
        if ( prevNote ) {
            // Capture unsaved textarea draft before cleanup/render can remove it.
            const liveDraftContent = getLiveNoteDraftContent( prevNote.id );
            if ( liveDraftContent !== null && liveDraftContent !== prevNote.content ) {
                prevNote.content = liveDraftContent;
                saveState();
            }
        }
        if ( prevNote && prevNote.content.trim() === '' && prevNote.color === NOTE_COLORS[ 0 ] ) {
            const idx = tab.notes.indexOf( prevNote );
            if ( idx >= 0 ) tab.notes.splice( idx, 1 );
        }
        lastAutoCreatedNoteId = null;
    }

    const note = createNote( '', x || 100, y || 100, NOTE_COLORS[ 0 ] );
    if ( boxIndex !== undefined ) {
        note.boxIndex = boxIndex;
    } else if ( tab.layout !== 'empty' && tab.boxes.length > 0 ) {
        note.boxIndex = 0;
    }
    tab.notes.push( note );
    lastAutoCreatedNoteId = note.id;
    saveState();
    renderCanvas();

    // Auto-enter edit mode
    setTimeout( () => {
        const noteEl = dom.canvas.querySelector( `[data-note-id="${ note.id }"]` );
        if ( noteEl ) enterEditMode( noteEl, note );
    }, 50 );
}

function isCanvasNoteCreateTarget( target ) {
    return target === dom.canvas || target.classList.contains( 'layout-box' ) ||
        target.classList.contains( 'layout-container' ) || target.classList.contains( 'layout-box-header' );
}

function addNoteAtClientPosition( clientX, clientY ) {
    const tab = getActiveTab();
    if ( ! tab || tab.isRecycleBin ) return;

    const canvasRect = dom.canvas.getBoundingClientRect();
    const pxX = clientX - canvasRect.left + dom.canvas.scrollLeft;
    const pxY = clientY - canvasRect.top + dom.canvas.scrollTop;
    const x = ( pxX / canvasRect.width ) * 100;
    const y = ( pxY / canvasRect.height ) * 100;

    let boxIndex = undefined;
    if ( tab.layout !== 'empty' && tab.boxes.length > 0 ) {
        boxIndex = getBoxIndexAtPosition( x, y );
    }
    addNewNote( x, y, boxIndex );
}

function promptDeleteOrRecycleNote( noteId, tabId ) {
    const tab = getTabById( tabId || activeTabId );
    if ( ! tab || tab.isRecycleBin ) return;

    if ( state.settings.recycleBin.instantDelete ) {
        showConfirmDialog( t( 'confirm_delete_permanent_title' ), t( 'confirm_delete_single_message' ), () => {
            deleteNote( noteId, tab.id );
            renderCanvas();
        } );
    } else {
        showConfirmDialog( t( 'confirm_move_recycle_title' ), t( 'confirm_move_recycle_message' ), () => {
            moveNoteToRecycleBin( noteId, tab.id );
            renderCanvas();
        } );
    }
}

function deleteNote( noteId, tabId ) {
    const tab = getTabById( tabId || activeTabId );
    if ( ! tab ) return;
    const idx = tab.notes.findIndex( n => n.id === noteId );
    if ( idx >= 0 ) tab.notes.splice( idx, 1 );
    saveState();
}

function moveNoteToRecycleBin( noteId, fromTabId ) {
    const fromTab = getTabById( fromTabId );
    const recycleBin = state.tabs.find( t => t.isRecycleBin );
    if ( ! fromTab || ! recycleBin ) return;

    const noteIdx = fromTab.notes.findIndex( n => n.id === noteId );
    if ( noteIdx < 0 ) return;

    const note = fromTab.notes.splice( noteIdx, 1 )[ 0 ];
    note.recycledAt = Date.now();
    note.boxIndex = -1;
    recycleBin.notes.push( note );
    saveState();
}

function moveNoteToTab( noteId, fromTabId, toTabId ) {
    const fromTab = getTabById( fromTabId );
    const toTab = getTabById( toTabId );
    if ( ! fromTab || ! toTab || fromTabId === toTabId ) return;

    const noteIdx = fromTab.notes.findIndex( n => n.id === noteId );
    if ( noteIdx < 0 ) return;

    const note = fromTab.notes.splice( noteIdx, 1 )[ 0 ];
    if ( toTab.isRecycleBin ) {
        note.recycledAt = Date.now();
    }
    note.boxIndex = toTab.layout !== 'empty' && toTab.boxes.length > 0 ? 0 : -1;
    toTab.notes.push( note );
    saveState();
}

function enterEditMode( noteEl, note ) {
    // Exit any current edit mode
    exitAllEditModes();

    noteEl.classList.add( 'editing' );
    const contentEl = noteEl.querySelector( '.note-content' );
    contentEl.style.display = 'none';

    const textarea = document.createElement( 'textarea' );
    textarea.value = note.content;
    textarea.maxLength = CONFIG.MAX_NOTE_CHARS;
    textarea.style.minHeight = '40px';
    noteEl.insertBefore( textarea, noteEl.querySelector( '.note-color-bar' ) );

    textarea.focus();
    autoResizeTextarea( textarea );

    textarea.addEventListener( 'input', () => {
        autoResizeTextarea( textarea );
    } );

    textarea.addEventListener( 'keydown', ( e ) => {
        if ( e.key === 'Escape' ) {
            exitEditMode( noteEl, note, textarea, false );
        }
    } );

    // Prevent color swatch mousedown from stealing focus
    noteEl.querySelectorAll( '.note-color-swatch' ).forEach( swatch => {
        swatch.addEventListener( 'mousedown', ( e ) => {
            e.preventDefault();
        } );
    } );

    textarea.addEventListener( 'blur', ( e ) => {
        // Delay to check if focus moved within the note
        setTimeout( () => {
            // If still in edit mode and focus is not inside the note, exit
            if ( noteEl.classList.contains( 'editing' ) && ! noteEl.contains( document.activeElement ) ) {
                exitEditMode( noteEl, note, textarea, true );
            }
        }, 200 );
    } );
}

function exitEditMode( noteEl, note, textarea, save ) {
    if ( ! noteEl.classList.contains( 'editing' ) ) return;
    if ( save ) {
        note.content = textarea.value;
        saveState();
    }
    // If note has content or color changed, it is no longer a candidate for auto-removal
    if ( note.content.trim() !== '' || note.color !== NOTE_COLORS[ 0 ] ) {
        if ( lastAutoCreatedNoteId === note.id ) {
            lastAutoCreatedNoteId = null;
        }
    }
    noteEl.classList.remove( 'editing' );
    const contentEl = noteEl.querySelector( '.note-content' );
    contentEl.textContent = note.content;
    contentEl.style.display = '';
    if ( textarea.parentNode ) textarea.remove();
}

function exitAllEditModes() {
    dom.canvas.querySelectorAll( '.note.editing' ).forEach( el => {
        const noteId = el.dataset.noteId;
        const tab = getActiveTab();
        if ( ! tab ) return;
        const note = tab.notes.find( n => n.id === noteId );
        const textarea = el.querySelector( 'textarea' );
        if ( note && textarea ) {
            exitEditMode( el, note, textarea, true );
        }
    } );
}

function autoResizeTextarea( textarea ) {
    textarea.style.height = 'auto';
    textarea.style.height = Math.min( textarea.scrollHeight, 300 ) + 'px';
}

// ---- Drag & Drop Notes ----

function startNoteDrag( noteEl, startX, startY ) {
    const noteId = noteEl.dataset.noteId;
    const tab = getActiveTab();
    if ( ! tab ) return;
    const note = tab.notes.find( n => n.id === noteId );
    if ( ! note ) return;

    const rect = noteEl.getBoundingClientRect();
    const canvasRect = dom.canvas.getBoundingClientRect();
    const offsetX = startX - rect.left;
    const offsetY = startY - rect.top;

    // Check if multiple notes selected
    const selectedNotes = getSelectedNoteIds();
    const isMulti = selectedNotes.includes( noteId ) && selectedNotes.length > 1;
    const dragIds = isMulti ? selectedNotes : [ noteId ];

    bringNotesToFront( tab, dragIds, noteId );

    dragState = {
        type: 'note',
        noteId: noteId,
        tabId: activeTabId,
        offsetX: offsetX,
        offsetY: offsetY,
        startX: startX,
        startY: startY,
        moved: false,
        isMulti: isMulti,
        selectedIds: dragIds,
        hoverTabId: null,
        hoverTabTimer: null
    };

    if ( isMulti ) {
        dragState.selectedIds.forEach( id => {
            const el = dom.canvas.querySelector( `[data-note-id="${ id }"]` );
            if ( el ) el.classList.add( 'dragging' );
        } );
    } else {
        noteEl.classList.add( 'dragging' );
    }
}

function getNoteContainerRect() {
    // Notes are always positioned relative to the canvas
    return dom.canvas.getBoundingClientRect();
}

function getBoxIndexAtPosition( xPercent, yPercent ) {
    // Determine which layout box a percentage position falls into
    const boxes = dom.canvas.querySelectorAll( '.layout-box' );
    if ( boxes.length === 0 ) return -1;

    const canvasRect = dom.canvas.getBoundingClientRect();
    const absX = canvasRect.left + ( xPercent / 100 ) * canvasRect.width;
    const absY = canvasRect.top + ( yPercent / 100 ) * canvasRect.height;

    for ( let i = 0; i < boxes.length; i++ ) {
        const rect = boxes[ i ].getBoundingClientRect();
        if ( absX >= rect.left && absX <= rect.right && absY >= rect.top && absY <= rect.bottom ) {
            return i;
        }
    }
    return 0; // Default to first box if outside all boxes
}

function handleNoteDrag( clientX, clientY ) {
    if ( ! dragState || dragState.type !== 'note' ) return;

    const dx = clientX - dragState.startX;
    const dy = clientY - dragState.startY;

    if ( ! dragState.moved && ( Math.abs( dx ) > 5 || Math.abs( dy ) > 5 ) ) {
        dragState.moved = true;
    }

    if ( ! dragState.moved ) return;

    const tab = getActiveTab();
    if ( ! tab ) return;

    // Move notes - calculate in pixels, store as percentages
    const containerRect = getNoteContainerRect();
    const cw = containerRect.width;
    const ch = containerRect.height;

    if ( dragState.isMulti ) {
        dragState.selectedIds.forEach( id => {
            const note = tab.notes.find( n => n.id === id );
            const el = dom.canvas.querySelector( `[data-note-id="${ id }"]` );
            if ( note && el ) {
                let pxX, pxY;
                if ( id === dragState.noteId ) {
                    pxX = clientX - containerRect.left - dragState.offsetX;
                    pxY = clientY - containerRect.top - dragState.offsetY;
                } else {
                    pxX = ( note.x / 100 ) * cw + ( dx - ( dragState.lastDx || 0 ) );
                    pxY = ( note.y / 100 ) * ch + ( dy - ( dragState.lastDy || 0 ) );
                }
                note.x = Math.max( 0, ( pxX / cw ) * 100 );
                note.y = Math.max( 0, ( pxY / ch ) * 100 );
                el.style.left = note.x + '%';
                el.style.top = note.y + '%';
            }
        } );
        dragState.lastDx = dx;
        dragState.lastDy = dy;
    } else {
        const note = tab.notes.find( n => n.id === dragState.noteId );
        const el = dom.canvas.querySelector( `[data-note-id="${ dragState.noteId }"]` );
        if ( note && el ) {
            const pxX = clientX - containerRect.left - dragState.offsetX;
            const pxY = clientY - containerRect.top - dragState.offsetY;
            note.x = Math.max( 0, ( pxX / cw ) * 100 );
            note.y = Math.max( 0, ( pxY / ch ) * 100 );
            el.style.left = note.x + '%';
            el.style.top = note.y + '%';
        }
    }

    // Check if hovering over a tab
    checkTabHover( clientX, clientY );
}

function checkTabHover( clientX, clientY ) {
    const tabs = dom.tabBar.querySelectorAll( '.tab[data-tab-id]' );
    let foundTabId = null;

    tabs.forEach( tabEl => {
        const rect = tabEl.getBoundingClientRect();
        if ( clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom ) {
            foundTabId = tabEl.dataset.tabId;
            tabEl.classList.add( 'drag-over' );
        } else {
            tabEl.classList.remove( 'drag-over' );
        }
    } );

    const targetTab = foundTabId ? getTabById( foundTabId ) : null;

    if ( foundTabId && foundTabId !== dragState.tabId ) {
        if ( dragState.hoverTabId !== foundTabId ) {
            clearTimeout( dragState.hoverTabTimer );
            dragState.hoverTabId = foundTabId;

            if ( targetTab && targetTab.isRecycleBin ) {
                // Recycle bin: no wait needed, just highlight
            } else {
                dragState.hoverTabTimer = setTimeout( () => {
                    if ( dragState && dragState.hoverTabId === foundTabId ) {
                        // Switch to that tab but keep dragging
                        switchToTabKeepDrag( foundTabId );
                    }
                }, CONFIG.TAB_SWITCH_HOLD_MS );
            }
        }
    } else {
        if ( dragState.hoverTabId ) {
            clearTimeout( dragState.hoverTabTimer );
            dragState.hoverTabId = null;
        }
    }
}

function switchToTabKeepDrag( tabId ) {
    // Move notes to new tab first
    const fromTab = getTabById( dragState.tabId );
    const toTab = getTabById( tabId );
    if ( ! fromTab || ! toTab ) return;

    dragState.selectedIds.forEach( id => {
        moveNoteToTab( id, dragState.tabId, tabId );
    } );

    dragState.tabId = tabId;
    activeTabId = tabId;
    renderTabs();
    renderCanvas();
}

function endNoteDrag( clientX, clientY ) {
    if ( ! dragState || dragState.type !== 'note' ) return;

    // Clear tab hover states
    dom.tabBar.querySelectorAll( '.tab' ).forEach( t => t.classList.remove( 'drag-over' ) );
    clearTimeout( dragState.hoverTabTimer );

    // Check if dropped on a tab
    if ( dragState.moved && dragState.hoverTabId && dragState.hoverTabId !== dragState.tabId ) {
        const targetTab = getTabById( dragState.hoverTabId );

        if ( targetTab && targetTab.isRecycleBin ) {
            // Handle recycle bin drop
            if ( state.settings.recycleBin.instantDelete ) {
                showConfirmDialog( t( 'confirm_delete_permanent_title' ), t( 'confirm_delete_single_message' ), () => {
                    dragState.selectedIds.forEach( id => {
                        deleteNote( id, dragState.tabId );
                    } );
                    renderCanvas();
                    dragState = null;
                } );
                // Remove dragging class before dialog
                dom.canvas.querySelectorAll( '.note.dragging' ).forEach( el => el.classList.remove( 'dragging' ) );
                return;
            } else {
                dragState.selectedIds.forEach( id => {
                    moveNoteToRecycleBin( id, dragState.tabId );
                } );
                renderCanvas();
            }
        } else {
            dragState.selectedIds.forEach( id => {
                moveNoteToTab( id, dragState.tabId, dragState.hoverTabId );
            } );
            // Do NOT switch tab - stay on current tab
            renderCanvas();
        }
    }

    // Remove dragging class
    dom.canvas.querySelectorAll( '.note.dragging' ).forEach( el => el.classList.remove( 'dragging' ) );

    if ( dragState && dragState.moved ) {
        // Update boxIndex based on note position in layout tabs
        const tab = getActiveTab();
        if ( tab && tab.layout !== 'empty' && tab.boxes.length > 0 ) {
            dragState.selectedIds.forEach( id => {
                const note = tab.notes.find( n => n.id === id );
                if ( note ) {
                    // Use note center point (add half note width/height as percentage of canvas)
                    const canvasRect = dom.canvas.getBoundingClientRect();
                    const halfW = ( CONFIG.NOTE_WIDTH / 2 / canvasRect.width ) * 100;
                    const halfH = ( CONFIG.NOTE_MIN_HEIGHT / 2 / canvasRect.height ) * 100;
                    note.boxIndex = getBoxIndexAtPosition( note.x + halfW, note.y + halfH );
                }
            } );
        }
        saveState();
    }
    dragState = null;
}

// ---- Selection ----

function getSelectedNoteIds() {
    const selected = [];
    dom.canvas.querySelectorAll( '.note.selected' ).forEach( el => {
        selected.push( el.dataset.noteId );
    } );
    return selected;
}

function clearSelection() {
    dom.canvas.querySelectorAll( '.note.selected' ).forEach( el => {
        el.classList.remove( 'selected' );
    } );
}

function startSelectionBox( x, y ) {
    const canvasRect = dom.canvas.getBoundingClientRect();
    selectionState = {
        startX: x - canvasRect.left + dom.canvas.scrollLeft,
        startY: y - canvasRect.top + dom.canvas.scrollTop,
        active: true
    };

    const box = document.createElement( 'div' );
    box.className = 'selection-box';
    box.id = 'selectionBox';
    dom.canvas.appendChild( box );
}

function updateSelectionBox( x, y ) {
    if ( ! selectionState || ! selectionState.active ) return;
    const canvasRect = dom.canvas.getBoundingClientRect();
    const curX = x - canvasRect.left + dom.canvas.scrollLeft;
    const curY = y - canvasRect.top + dom.canvas.scrollTop;

    const box = document.getElementById( 'selectionBox' );
    if ( ! box ) return;

    const left = Math.min( selectionState.startX, curX );
    const top = Math.min( selectionState.startY, curY );
    const width = Math.abs( curX - selectionState.startX );
    const height = Math.abs( curY - selectionState.startY );

    box.style.left = left + 'px';
    box.style.top = top + 'px';
    box.style.width = width + 'px';
    box.style.height = height + 'px';

    // Highlight notes within selection
    const selRect = { left, top, right: left + width, bottom: top + height };
    dom.canvas.querySelectorAll( '.note' ).forEach( el => {
        const noteRect = {
            left: el.offsetLeft,
            top: el.offsetTop,
            right: el.offsetLeft + el.offsetWidth,
            bottom: el.offsetTop + el.offsetHeight
        };
        if ( rectsOverlap( selRect, noteRect ) ) {
            el.classList.add( 'selected' );
        } else if ( ! selectionState.ctrlHeld ) {
            el.classList.remove( 'selected' );
        }
    } );
}

function endSelectionBox() {
    if ( ! selectionState ) return;
    selectionState = null;
    const box = document.getElementById( 'selectionBox' );
    if ( box ) box.remove();
}

function rectsOverlap( a, b ) {
    return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
}

// ---- Tab Settings Modal ----

function openTabSettings( tabId ) {
    const tab = getTabById( tabId );
    if ( ! tab || tab.isRecycleBin ) return;

    // Backup current state for cancel/preview
    tabSettingsBackup = JSON.parse( JSON.stringify( tab ) );

    dom.tabNameInput.value = tab.name;
    dom.tabNameInput.maxLength = CONFIG.MAX_TAB_NAME;
    dom.tabNameInput.placeholder = t( 'tab_name_placeholder' );

    // Render color picker
    dom.tabColorPicker.innerHTML = '';
    TAB_COLORS.forEach( c => {
        const swatch = document.createElement( 'div' );
        swatch.className = 'color-swatch' + ( c === tab.color ? ' active' : '' );
        swatch.style.background = c;
        swatch.dataset.color = c;
        swatch.addEventListener( 'click', () => {
            dom.tabColorPicker.querySelectorAll( '.color-swatch' ).forEach( s => s.classList.remove( 'active' ) );
            swatch.classList.add( 'active' );
            // Preview color
            tab.color = c;
            renderTabs();
        } );
        dom.tabColorPicker.appendChild( swatch );
    } );

    dom.tabLayoutSelect.value = tab.layout;
    renderLayoutBoxSettings( tab );

    dom.tabLayoutSelect.onchange = () => {
        const newLayout = dom.tabLayoutSelect.value;
        // Preserve existing box settings if same number, otherwise reset
        if ( newLayout !== tab.layout ) {
            tab.layout = newLayout;
            tab.boxes = getLocalizedLayoutBoxes( newLayout, getCurrentLanguage() );
        }
        renderLayoutBoxSettings( tab );
        renderCanvas();
    };

    showModal( 'tabSettingsModal' );

    // Reset modal position
    dom.tabSettingsModal.style.left = '50%';
    dom.tabSettingsModal.style.top = '56px';
    dom.tabSettingsModal.style.transform = 'translateX(-50%)';
}

function renderLayoutBoxSettings( tab ) {
    const container = dom.layoutBoxSettings;
    container.innerHTML = '';

    if ( ! tab.boxes || tab.boxes.length === 0 ) {
        container.classList.add( 'hidden' );
        return;
    }

    container.classList.remove( 'hidden' );
    const h4 = document.createElement( 'h4' );
    h4.textContent = t( 'tab_box_settings' );
    container.appendChild( h4 );

    tab.boxes.forEach( ( box, i ) => {
        const row = document.createElement( 'div' );
        row.className = 'box-setting-row';

        const nameInput = document.createElement( 'input' );
        nameInput.type = 'text';
        nameInput.value = box.name;
        nameInput.maxLength = CONFIG.MAX_BOX_NAME;
        nameInput.placeholder = t( 'tab_box_name_placeholder' );
        nameInput.addEventListener( 'input', () => {
            box.name = nameInput.value;
            // Preview
            renderCanvas();
        } );
        row.appendChild( nameInput );

        const colorBtn = document.createElement( 'div' );
        colorBtn.className = 'box-color-btn';
        colorBtn.style.background = box.color;
        colorBtn.title = t( 'tab_change_color' );
        colorBtn.addEventListener( 'click', ( e ) => {
            e.stopPropagation();
            // Toggle color picker
            const existing = colorBtn.querySelector( '.box-color-picker' );
            if ( existing ) {
                existing.remove();
                return;
            }
            // Close other pickers
            container.querySelectorAll( '.box-color-picker' ).forEach( p => p.remove() );

            const picker = document.createElement( 'div' );
            picker.className = 'box-color-picker';
            BOX_COLORS.forEach( c => {
                const s = document.createElement( 'div' );
                s.className = 'color-swatch';
                s.style.background = c;
                s.addEventListener( 'click', ( ev ) => {
                    ev.stopPropagation();
                    box.color = c;
                    colorBtn.style.background = c;
                    picker.remove();
                    renderCanvas();
                } );
                picker.appendChild( s );
            } );
            // Add some extra colors
            [ 'rgba(80,50,50,0.35)', 'rgba(50,80,50,0.35)', 'rgba(50,50,80,0.35)',
                'rgba(80,80,50,0.35)', 'rgba(50,80,80,0.35)', 'rgba(80,50,80,0.35)',
                'rgba(40,40,60,0.4)', 'rgba(60,40,40,0.4)', 'rgba(40,60,40,0.4)',
                'rgba(60,60,40,0.4)', 'rgba(40,60,60,0.4)', 'rgba(60,40,60,0.4)',
                'rgba(50,50,50,0.35)' ].forEach( c => {
                const s = document.createElement( 'div' );
                s.className = 'color-swatch';
                s.style.background = c;
                s.addEventListener( 'click', ( ev ) => {
                    ev.stopPropagation();
                    box.color = c;
                    colorBtn.style.background = c;
                    picker.remove();
                    renderCanvas();
                } );
                picker.appendChild( s );
            } );
            colorBtn.appendChild( picker );
        } );
        row.appendChild( colorBtn );

        container.appendChild( row );
    } );
}

function saveTabSettings() {
    const tab = getActiveTab();
    if ( ! tab ) return;
    tab.name = dom.tabNameInput.value.slice( 0, CONFIG.MAX_TAB_NAME );

    const selectedColor = dom.tabColorPicker.querySelector( '.color-swatch.active' );
    if ( selectedColor ) tab.color = selectedColor.dataset.color;

    tab.layout = dom.tabLayoutSelect.value;
    // Box settings already updated via preview

    tabSettingsBackup = null;
    saveState();
    renderTabs();
    renderCanvas();
    hideModal( 'tabSettingsModal' );
}

function cancelTabSettings() {
    if ( tabSettingsBackup ) {
        const tab = getActiveTab();
        if ( tab ) {
            Object.assign( tab, tabSettingsBackup );
        }
        tabSettingsBackup = null;
        saveState();
        renderTabs();
        renderCanvas();
    }
    hideModal( 'tabSettingsModal' );
}

// ---- App Settings ----

function openAppSettings() {
    dom.instantDeleteCheck.checked = state.settings.recycleBin.instantDelete;
    dom.autoDeleteCheck.checked = state.settings.recycleBin.autoDelete;
    dom.autoDeleteDays.value = state.settings.recycleBin.autoDeleteDays;
    updateAppSettingsUI();
    showModal( 'appSettingsModal' );
}

function updateAppSettingsUI() {
    const instant = dom.instantDeleteCheck.checked;
    dom.autoDeleteCheck.disabled = instant;
    dom.autoDeleteDays.disabled = instant || ! dom.autoDeleteCheck.checked;
    if ( instant ) {
        dom.autoDeleteCheck.checked = false;
    }
}

function saveAppSettings() {
    state.settings.recycleBin.instantDelete = dom.instantDeleteCheck.checked;
    state.settings.recycleBin.autoDelete = dom.autoDeleteCheck.checked;
    state.settings.recycleBin.autoDeleteDays = parseInt( dom.autoDeleteDays.value ) || 30;
    saveState();
    hideModal( 'appSettingsModal' );
    showNotification( t( 'notification_settings_saved' ) );
}

// ---- Recycle Bin Cleanup ----

function cleanRecycleBin() {
    if ( ! state.settings.recycleBin.autoDelete ) return;
    const recycleBin = state.tabs.find( t => t.isRecycleBin );
    if ( ! recycleBin ) return;

    const maxAge = state.settings.recycleBin.autoDeleteDays * 24 * 60 * 60 * 1000;
    const now = Date.now();
    const before = recycleBin.notes.length;

    recycleBin.notes = recycleBin.notes.filter( n => {
        if ( ! n.recycledAt ) return true;
        return ( now - n.recycledAt ) < maxAge;
    } );

    if ( recycleBin.notes.length !== before ) {
        saveState();
        if ( activeTabId === recycleBin.id ) renderCanvas();
    }
}

function emptyRecycleBin() {
    const recycleBin = state.tabs.find( t => t.isRecycleBin );
    if ( ! recycleBin || recycleBin.notes.length === 0 ) return;

    showConfirmDialog(
        t( 'confirm_empty_recycle_title' ),
        t( 'confirm_empty_recycle_message', { count: recycleBin.notes.length } ),
        () => {
            recycleBin.notes = [];
            saveState();
            renderCanvas();
            showNotification( t( 'notification_recycle_emptied' ) );
        }
    );
}

function deleteAllNotes() {
    let totalNotes = 0;
    state.tabs.forEach( tab => {
        totalNotes += tab.notes.length;
    } );

    if ( totalNotes === 0 ) {
        showNotification( t( 'notification_no_notes_delete' ) );
        return;
    }

    showConfirmDialog(
        t( 'confirm_delete_all_title' ),
        t( 'confirm_delete_all_message' ),
        () => {
            state.tabs.forEach( tab => {
                tab.notes = [];
            } );
            lastAutoCreatedNoteId = null;
            saveState();
            renderCanvas();
            showNotification( t( 'notification_all_notes_deleted' ) );
        }
    );
}

function resetApp() {
    showConfirmDialog(
        t( 'confirm_reset_title' ),
        t( 'confirm_reset_message' ),
        () => {
            localStorage.removeItem( CONFIG.STORAGE_KEY );
            window.location.reload();
        }
    );
}

// ---- Import / Export ----

function exportData() {
    const json = JSON.stringify( state, null, 2 );
    const blob = new Blob( [ json ], { type: 'application/json' } );
    const url = URL.createObjectURL( blob );
    const a = document.createElement( 'a' );
    a.href = url;
    a.download = CONFIG.EXPORT_FILENAME;
    document.body.appendChild( a );
    a.click();
    document.body.removeChild( a );
    URL.revokeObjectURL( url );
    showNotification( t( 'notification_exported' ) );
}

function importData( file ) {
    const reader = new FileReader();
    reader.onload = ( e ) => {
        try {
            const data = JSON.parse( e.target.result );
            if ( ! validateImportData( data ) ) {
                showNotification( t( 'notification_import_error' ) );
                return;
            }
            state = data;
            if ( ! state.settings ) state.settings = {};
            if ( ! state.settings.language ) state.settings.language = 'en';
            if ( ! SUPPORTED_LANGUAGES.includes( state.settings.language ) ) state.settings.language = 'en';
            // Ensure recycle bin exists
            if ( ! state.tabs.find( t => t.isRecycleBin ) ) {
                state.tabs.push( createRecycleBinTab() );
            }
            activeTabId = state.activeTabId || state.tabs[ 0 ].id;
            saveState();
            applyTheme();
            applyLanguage();
            renderTabs();
            renderCanvas();
            showNotification( t( 'notification_import_success' ) );
        } catch ( err ) {
            showNotification( t( 'notification_import_error' ) );
        }
    };
    reader.readAsText( file );
}

function validateImportData( data ) {
    if ( ! data || typeof data !== 'object' ) return false;
    if ( ! data.settings || typeof data.settings !== 'object' ) return false;
    if ( ! Array.isArray( data.tabs ) ) return false;
    if ( data.tabs.length === 0 ) return false;

    for ( const tab of data.tabs ) {
        if ( ! tab.id || typeof tab.id !== 'string' ) return false;
        if ( typeof tab.name !== 'string' && tab.name !== '' ) return false;
        if ( typeof tab.color !== 'string' ) return false;
        if ( typeof tab.layout !== 'string' ) return false;
        if ( ! Array.isArray( tab.notes ) ) return false;
        if ( ! Array.isArray( tab.boxes ) && tab.boxes !== undefined ) return false;

        for ( const note of tab.notes ) {
            if ( ! note.id || typeof note.id !== 'string' ) return false;
            if ( typeof note.content !== 'string' ) return false;
            if ( typeof note.color !== 'string' ) return false;
        }
    }

    if ( ! data.settings.recycleBin || typeof data.settings.recycleBin !== 'object' ) return false;
    if ( data.settings.language !== undefined && typeof data.settings.language !== 'string' ) return false;

    return true;
}

// ---- Modals ----

function showModal( id ) {
    dom.modalOverlay.classList.remove( 'hidden' );
    document.getElementById( id ).classList.remove( 'hidden' );
}

function hideModal( id ) {
    document.getElementById( id ).classList.add( 'hidden' );
    // Check if any modals still visible
    const anyOpen = document.querySelectorAll( '.modal:not(.hidden)' );
    if ( anyOpen.length === 0 ) {
        dom.modalOverlay.classList.add( 'hidden' );
    }
}

function hideAllModals() {
    document.querySelectorAll( '.modal' ).forEach( m => m.classList.add( 'hidden' ) );
    dom.modalOverlay.classList.add( 'hidden' );
}

let confirmCallback = null;

function showConfirmDialog( title, message, onConfirm ) {
    dom.confirmTitle.textContent = title;
    dom.confirmMessage.textContent = message;
    confirmCallback = onConfirm;
    showModal( 'confirmDialog' );
}

// ---- Notifications ----

let notificationTimer = null;

function showNotification( text ) {
    clearTimeout( notificationTimer );
    dom.notification.textContent = text;
    dom.notification.classList.remove( 'hidden' );
    notificationTimer = setTimeout( () => {
        dom.notification.classList.add( 'hidden' );
    }, 3000 );
}

// ---- Modal Dragging ----

function initModalDrag( handle, modal ) {
    handle.addEventListener( 'mousedown', ( e ) => {
        if ( e.target.classList.contains( 'modal-close' ) ) return;
        e.preventDefault();
        const rect = modal.getBoundingClientRect();
        modalDragState = {
            modal: modal,
            offsetX: e.clientX - rect.left,
            offsetY: e.clientY - rect.top
        };
    } );
}

// ---- Event Binding ----

function bindEvents() {
    let lastTouchStartTs = 0;

    // Hamburger menu
    dom.hamburgerBtn.addEventListener( 'click', ( e ) => {
        e.stopPropagation();
        dom.hamburgerMenu.classList.toggle( 'hidden' );
    } );

    document.addEventListener( 'click', ( e ) => {
        if ( ! dom.hamburgerMenu.classList.contains( 'hidden' ) &&
            ! dom.hamburgerMenu.contains( e.target ) &&
            e.target !== dom.hamburgerBtn ) {
            dom.hamburgerMenu.classList.add( 'hidden' );
        }
    } );

    // Menu items
    document.getElementById( 'menuHowTo' ).addEventListener( 'click', () => {
        dom.hamburgerMenu.classList.add( 'hidden' );
        showModal( 'howToModal' );
    } );

    document.getElementById( 'menuImport' ).addEventListener( 'click', () => {
        dom.hamburgerMenu.classList.add( 'hidden' );
        dom.importFileInput.click();
    } );

    document.getElementById( 'menuExport' ).addEventListener( 'click', () => {
        dom.hamburgerMenu.classList.add( 'hidden' );
        exportData();
    } );

    document.getElementById( 'menuDeleteAllNotes' ).addEventListener( 'click', () => {
        dom.hamburgerMenu.classList.add( 'hidden' );
        deleteAllNotes();
    } );

    document.getElementById( 'menuAppSettings' ).addEventListener( 'click', () => {
        dom.hamburgerMenu.classList.add( 'hidden' );
        openAppSettings();
    } );

    document.getElementById( 'menuResetApp' ).addEventListener( 'click', () => {
        dom.hamburgerMenu.classList.add( 'hidden' );
        resetApp();
    } );

    dom.importFileInput.addEventListener( 'change', ( e ) => {
        if ( e.target.files[ 0 ] ) {
            importData( e.target.files[ 0 ] );
            e.target.value = '';
        }
    } );

    // Theme mode buttons
    dom.themeBtns.forEach( btn => {
        btn.addEventListener( 'click', () => {
            state.settings.themeMode = btn.dataset.themeMode;
            applyTheme();
            saveState();
        } );
    } );

    dom.langBtns.forEach( btn => {
        btn.addEventListener( 'click', () => {
            setLanguage( btn.dataset.language );
        } );
    } );

    // Listen for system theme changes when in system mode
    window.matchMedia( '(prefers-color-scheme: dark)' ).addEventListener( 'change', () => {
        if ( state.settings.themeMode === 'system' ) {
            applyTheme();
        }
    } );

    // Tab bar clicks - use a delay to detect double-click vs single-click
    let tabClickTimer = null;
    let tabClickTabId = null;

    dom.tabBar.addEventListener( 'click', ( e ) => {
        const tab = e.target.closest( '.tab[data-tab-id]' );
        if ( tab ) {
            const clickedTabId = tab.dataset.tabId;

            // If there is a pending single-click on the same tab, treat as double-click
            if ( tabClickTimer && tabClickTabId === clickedTabId ) {
                clearTimeout( tabClickTimer );
                tabClickTimer = null;
                tabClickTabId = null;
                // Double-click action
                const tabData = getTabById( clickedTabId );
                if ( tabData && tabData.isRecycleBin ) {
                    switchToTab( clickedTabId );
                    emptyRecycleBin();
                } else if ( tabData ) {
                    switchToTab( clickedTabId );
                    openTabSettings( clickedTabId );
                }
                return;
            }

            // Start single-click timer
            tabClickTabId = clickedTabId;
            tabClickTimer = setTimeout( () => {
                tabClickTimer = null;
                tabClickTabId = null;
                switchToTab( clickedTabId );
            }, 250 );
            return;
        }
        if ( e.target.closest( '#addTabBtn' ) ) {
            addNewTab();
        }
    } );

    // Tab settings
    dom.tabSettingsSave.addEventListener( 'click', saveTabSettings );
    dom.tabSettingsCancel.addEventListener( 'click', cancelTabSettings );
    dom.tabSettingsDelete.addEventListener( 'click', promptDeleteTab );

    // App settings
    dom.instantDeleteCheck.addEventListener( 'change', updateAppSettingsUI );
    dom.autoDeleteCheck.addEventListener( 'change', updateAppSettingsUI );
    dom.appSettingsSave.addEventListener( 'click', saveAppSettings );
    dom.appSettingsCancel.addEventListener( 'click', () => hideModal( 'appSettingsModal' ) );

    // Confirm dialog
    dom.confirmYes.addEventListener( 'click', () => {
        hideModal( 'confirmDialog' );
        if ( confirmCallback ) {
            confirmCallback();
            confirmCallback = null;
        }
    } );
    dom.confirmNo.addEventListener( 'click', () => {
        hideModal( 'confirmDialog' );
        confirmCallback = null;
    } );

    // Modal close buttons
    document.querySelectorAll( '.modal-close' ).forEach( btn => {
        btn.addEventListener( 'click', () => {
            const modalId = btn.dataset.close;
            if ( modalId === 'tabSettingsModal' ) {
                cancelTabSettings();
            } else {
                hideModal( modalId );
            }
        } );
    } );

    // Modal overlay click
    dom.modalOverlay.addEventListener( 'click', () => {
        // Close tab settings with cancel
        if ( ! dom.tabSettingsModal.classList.contains( 'hidden' ) ) {
            cancelTabSettings();
        }
        hideAllModals();
    } );

    // Canvas right-click
    dom.canvas.addEventListener( 'contextmenu', ( e ) => {
        if ( Date.now() - lastTouchStartTs < 800 ) {
            e.preventDefault();
            return;
        }

        const noteEl = e.target.closest( '.note' );

        // Right-click on a note (not in edit mode): delete/recycle
        if ( noteEl && ! noteEl.classList.contains( 'editing' ) ) {
            e.preventDefault();
            const noteId = noteEl.dataset.noteId;
            promptDeleteOrRecycleNote( noteId, activeTabId );
            return;
        }

        // Right-click on canvas: add note
        if ( isCanvasNoteCreateTarget( e.target ) ) {
            e.preventDefault();
            addNoteAtClientPosition( e.clientX, e.clientY );
        }
    } );

    // Canvas mouse events for dragging and selection
    dom.canvas.addEventListener( 'mousedown', ( e ) => {
        if ( e.button !== 0 ) return;

        const noteEl = e.target.closest( '.note' );

        const deleteBtn = e.target.closest( '.note-delete-btn' );
        if ( deleteBtn ) {
            e.preventDefault();
            e.stopPropagation();
            if ( noteEl ) {
                promptDeleteOrRecycleNote( noteEl.dataset.noteId, activeTabId );
            }
            return;
        }

        // Check for color swatch
        if ( e.target.classList.contains( 'note-color-swatch' ) ) {
            e.stopPropagation();
            changeNoteColor( noteEl, e.target.dataset.color );
            return;
        }

        if ( noteEl ) {
            // If note is in edit mode, don't start drag
            if ( noteEl.classList.contains( 'editing' ) ) return;

            // Don't start drag for recycle bin notes (double-click handles deletion)
            const activeTab = getActiveTab();
            if ( activeTab && activeTab.isRecycleBin ) return;

            // Ctrl+click for multi-select
            if ( e.ctrlKey || e.metaKey ) {
                noteEl.classList.toggle( 'selected' );
                return;
            }

            startNoteDrag( noteEl, e.clientX, e.clientY );
        } else if ( e.target === dom.canvas || e.target.classList.contains( 'layout-container' ) ||
            e.target.classList.contains( 'layout-box' ) || e.target.classList.contains( 'layout-box-header' ) ) {
            // Start selection box on canvas
            if ( ! e.ctrlKey && ! e.metaKey ) {
                clearSelection();
            }
            selectionState = { ctrlHeld: e.ctrlKey || e.metaKey };
            startSelectionBox( e.clientX, e.clientY );
        }
    } );

    // Touch support for double-tap actions and dragging notes (mobile/tablet)
    const getTouchPoint = ( touchEvent ) => {
        const t = touchEvent.touches[ 0 ] || touchEvent.changedTouches[ 0 ];
        if ( ! t ) return null;
        return { x: t.clientX, y: t.clientY };
    };

    const TOUCH_DRAG_THRESHOLD = 8;
    const TOUCH_TAP_MAX_MS = 250;
    const TOUCH_DOUBLE_TAP_MS = 320;
    const TOUCH_DOUBLE_TAP_DIST = 24;
    const TOUCH_LONG_PRESS_MS = 450;
    let touchState = null;
    let lastTapInfo = null;

    dom.canvas.addEventListener( 'touchstart', ( e ) => {
        lastTouchStartTs = Date.now();
        const target = e.target;
        const noteEl = target.closest( '.note' );
        const point = getTouchPoint( e );
        if ( ! point ) return;

        if ( target.classList.contains( 'note-color-swatch' ) ) {
            e.preventDefault();
            e.stopPropagation();
            changeNoteColor( noteEl, target.dataset.color );
            return;
        }

        const deleteBtn = target.closest( '.note-delete-btn' );
        if ( deleteBtn ) {
            e.preventDefault();
            e.stopPropagation();
            if ( noteEl ) {
                promptDeleteOrRecycleNote( noteEl.dataset.noteId, activeTabId );
            }
            return;
        }

        const canCreate = isCanvasNoteCreateTarget( target );
        const canEdit = noteEl && ! noteEl.classList.contains( 'editing' );
        if ( ! canCreate && ! canEdit ) return;

        touchState = {
            startX: point.x,
            startY: point.y,
            startTs: Date.now(),
            noteEl: canEdit ? noteEl : null,
            createTarget: canCreate && ! canEdit,
            moved: false,
            longPressTriggered: false,
            longPressTimer: null
        };

        if ( touchState.createTarget ) {
            touchState.longPressTimer = setTimeout( () => {
                if ( ! touchState || touchState.moved || ! touchState.createTarget ) return;
                touchState.longPressTriggered = true;
                clearSelection();
                selectionState = { ctrlHeld: false };
                startSelectionBox( touchState.startX, touchState.startY );
            }, TOUCH_LONG_PRESS_MS );
        }
    }, { passive: false } );

    document.addEventListener( 'touchmove', ( e ) => {
        const point = getTouchPoint( e );
        if ( ! point ) return;

        if ( selectionState && selectionState.active ) {
            e.preventDefault();
            updateSelectionBox( point.x, point.y );
            return;
        }

        if ( touchState ) {
            const dx = point.x - touchState.startX;
            const dy = point.y - touchState.startY;
            const moved = Math.sqrt( dx * dx + dy * dy ) > TOUCH_DRAG_THRESHOLD;

            if ( moved ) {
                touchState.moved = true;
                if ( touchState.longPressTimer ) {
                    clearTimeout( touchState.longPressTimer );
                    touchState.longPressTimer = null;
                }
                if ( touchState.noteEl && ( ! dragState || dragState.type !== 'note' ) ) {
                    startNoteDrag( touchState.noteEl, touchState.startX, touchState.startY );
                }
            }

            if ( ! dragState || dragState.type !== 'note' ) {
                return;
            }
        }

        if ( ! dragState || dragState.type !== 'note' ) return;
        e.preventDefault();
        handleNoteDrag( point.x, point.y );
    }, { passive: false } );

    const handleTouchEnd = ( e ) => {
        const point = getTouchPoint( e );
        const endedTouchState = touchState;
        touchState = null;

        if ( endedTouchState && endedTouchState.longPressTimer ) {
            clearTimeout( endedTouchState.longPressTimer );
        }

        if ( selectionState && selectionState.active ) {
            endSelectionBox();
            return;
        }

        if ( endedTouchState && ! endedTouchState.moved && ! endedTouchState.longPressTriggered ) {
            const tapDuration = Date.now() - endedTouchState.startTs;
            if ( tapDuration <= TOUCH_TAP_MAX_MS ) {
                const tapType = endedTouchState.noteEl ? 'note' : ( endedTouchState.createTarget ? 'canvas' : null );
                const tapId = endedTouchState.noteEl ? endedTouchState.noteEl.dataset.noteId : 'canvas';

                if ( tapType ) {
                    const currentTap = {
                        type: tapType,
                        id: tapId,
                        x: endedTouchState.startX,
                        y: endedTouchState.startY,
                        ts: Date.now()
                    };

                    if ( lastTapInfo ) {
                        const dt = currentTap.ts - lastTapInfo.ts;
                        const ddx = currentTap.x - lastTapInfo.x;
                        const ddy = currentTap.y - lastTapInfo.y;
                        const near = Math.sqrt( ddx * ddx + ddy * ddy ) <= TOUCH_DOUBLE_TAP_DIST;
                        const sameTarget = currentTap.type === lastTapInfo.type && currentTap.id === lastTapInfo.id;

                        if ( sameTarget && dt <= TOUCH_DOUBLE_TAP_MS && near ) {
                            if ( currentTap.type === 'note' ) {
                                const tab = getActiveTab();
                                if ( tab && ! tab.isRecycleBin ) {
                                    const noteEl = dom.canvas.querySelector( `[data-note-id="${ currentTap.id }"]` );
                                    const note = tab.notes.find( n => n.id === currentTap.id );
                                    if ( noteEl && note ) enterEditMode( noteEl, note );
                                }
                            } else if ( currentTap.type === 'canvas' ) {
                                addNoteAtClientPosition( currentTap.x, currentTap.y );
                            }
                            lastTapInfo = null;
                        } else {
                            lastTapInfo = currentTap;
                        }
                    } else {
                        lastTapInfo = currentTap;
                    }
                }
            }
        }

        if ( ! dragState || dragState.type !== 'note' ) return;
        if ( point ) {
            endNoteDrag( point.x, point.y );
        } else {
            endNoteDrag( 0, 0 );
        }
    };

    document.addEventListener( 'touchend', handleTouchEnd );
    document.addEventListener( 'touchcancel', handleTouchEnd );

    document.addEventListener( 'mousemove', ( e ) => {
        if ( dragState && dragState.type === 'note' ) {
            handleNoteDrag( e.clientX, e.clientY );
        } else if ( selectionState && selectionState.active ) {
            updateSelectionBox( e.clientX, e.clientY );
        }

        // Modal drag
        if ( modalDragState ) {
            const x = e.clientX - modalDragState.offsetX;
            const y = e.clientY - modalDragState.offsetY;
            modalDragState.modal.style.left = x + 'px';
            modalDragState.modal.style.top = y + 'px';
            modalDragState.modal.style.transform = 'none';
        }
    } );

    document.addEventListener( 'mouseup', ( e ) => {
        if ( dragState && dragState.type === 'note' ) {
            endNoteDrag( e.clientX, e.clientY );
        }
        if ( selectionState ) {
            endSelectionBox();
        }
        if ( modalDragState ) {
            modalDragState = null;
        }
    } );

    // Double-click on note to edit (or permanently delete in recycle bin)
    dom.canvas.addEventListener( 'dblclick', ( e ) => {
        const noteEl = e.target.closest( '.note' );
        if ( ! noteEl ) return;
        const tab = getActiveTab();
        if ( ! tab ) return;

        if ( tab.isRecycleBin ) {
            const noteId = noteEl.dataset.noteId;
            showConfirmDialog( t( 'confirm_delete_permanent_title' ), t( 'confirm_delete_single_message' ), () => {
                deleteNote( noteId, tab.id );
                renderCanvas();
            } );
            return;
        }

        const note = tab.notes.find( n => n.id === noteEl.dataset.noteId );
        if ( note ) {
            enterEditMode( noteEl, note );
        }
    } );

    // Keyboard shortcuts
    document.addEventListener( 'keydown', ( e ) => {
        if ( e.key === 'Escape' ) {
            exitAllEditModes();
            hideAllModals();
            clearSelection();
        }
        if ( e.key === 'Delete' || e.key === 'Backspace' ) {
            // Delete selected notes if not editing
            if ( ! document.querySelector( '.note.editing' ) && ! document.querySelector( '.modal:not(.hidden)' ) ) {
                const selected = getSelectedNoteIds();
                if ( selected.length > 0 ) {
                    const tab = getActiveTab();
                    if ( tab && ! tab.isRecycleBin ) {
                        if ( state.settings.recycleBin.instantDelete ) {
                            showConfirmDialog( t( 'confirm_delete_permanent_title' ), t( 'confirm_delete_multi_message', { count: selected.length } ), () => {
                                selected.forEach( id => deleteNote( id ) );
                                renderCanvas();
                            } );
                        } else {
                            selected.forEach( id => moveNoteToRecycleBin( id, activeTabId ) );
                            renderCanvas();
                        }
                    }
                }
            }
        }
    } );

    // Init modal drag for tab settings
    const dragHandle = dom.tabSettingsModal.querySelector( '.modal-drag-handle' );
    if ( dragHandle ) {
        initModalDrag( dragHandle, dom.tabSettingsModal );
    }
}

// ---- Note Helpers ----

function changeNoteColor( noteEl, color ) {
    if ( ! noteEl ) return;
    const tab = getActiveTab();
    if ( ! tab ) return;
    const note = tab.notes.find( n => n.id === noteEl.dataset.noteId );
    if ( ! note ) return;

    note.color = color;
    noteEl.style.background = color;

    // Update active swatch
    noteEl.querySelectorAll( '.note-color-swatch' ).forEach( s => {
        s.classList.toggle( 'active', s.dataset.color === color );
    } );

    saveState();
}

// ---- i18n ----

const SUPPORTED_LANGUAGES = [ 'en', 'de' ];

const TRANSLATIONS = {
    theme_light_title: { en: 'Light mode', de: 'Hell' },
    theme_system_title: { en: 'System preference', de: 'Systemeinstellung' },
    theme_dark_title: { en: 'Dark mode', de: 'Dunkel' },
    language_en_title: { en: 'English', de: 'Englisch' },
    language_de_title: { en: 'German', de: 'Deutsch' },

    menu_how_to: { en: 'How To Use', de: 'Anleitung' },
    menu_import: { en: 'Import', de: 'Importieren' },
    menu_export: { en: 'Export', de: 'Exportieren' },
    menu_delete_all_notes: { en: 'Delete all Notes', de: 'Alle Notizen löschen' },
    menu_app_settings: { en: 'App Settings', de: 'App-Einstellungen' },
    menu_reset_app: { en: 'Reset App', de: 'App zurücksetzen' },

    howto_notes_title: { en: 'Notes', de: 'Notizen' },
    howto_note_create: {
        en: '<strong>Create:</strong> Right-click (or double-tap) on the canvas',
        de: '<strong>Erstellen:</strong> Rechtsklick (oder doppelt antippen) auf freier Fläche'
    },
    howto_note_edit: {
        en: '<strong>Edit:</strong> Double-click (or double-tap) a note',
        de: '<strong>Bearbeiten:</strong> Doppelklick (oder doppelt antippen) auf eine Notiz'
    },
    howto_note_move: {
        en: '<strong>Move:</strong> Click (or touch) and drag',
        de: '<strong>Verschieben:</strong> Klicken (oder tippen) und ziehen'
    },
    howto_note_color: {
        en: '<strong>Change color:</strong> Select a color in edit mode',
        de: '<strong>Farbe ändern:</strong> Farbe im Bearbeitungsmodus wählen'
    },
    howto_note_delete: {
        en: '<strong>Delete:</strong> Use the trash button in edit mode, right-click a note, or drag it onto the recycle bin tab',
        de: '<strong>Löschen:</strong> Papierkorb-Button im Bearbeitungsmodus nutzen, Rechtsklick auf Notiz oder auf den Papierkorb-Tab ziehen'
    },
    howto_note_select: {
        en: '<strong>Multi-select:</strong> Hold Ctrl/Cmd and click notes or click (or long-press) on empty canvas and drag a selection box',
        de: '<strong>Mehrfachauswahl:</strong> Strg/Cmd halten und Notizen klicken oder auf leerer Fläche klicken (oder lang drücken) und Auswahlrahmen ziehen'
    },

    howto_tabs_title: { en: 'Tabs', de: 'Tabs' },
    howto_tab_switch: { en: '<strong>Switch:</strong> Click on a tab', de: '<strong>Wechseln:</strong> Auf einen Tab klicken' },
    howto_tab_new: { en: '<strong>New:</strong> Click the + tab', de: '<strong>Neu:</strong> Auf den + Tab klicken' },
    howto_tab_edit: {
        en: '<strong>Edit:</strong> Double-click (or double-tap) on a tab to rename, change color, or set layout',
        de: '<strong>Bearbeiten:</strong> Doppelklick (oder doppelt antippen) auf einen Tab zum Umbenennen, Farbe ändern oder Layout setzen'
    },
    howto_tab_move: {
        en: '<strong>Move note to tab:</strong> Drag a note over a tab and hold for 1 second to switch, then drop',
        de: '<strong>Notiz zu Tab verschieben:</strong> Notiz über einen Tab ziehen und kurz halten, dann ablegen'
    },

    howto_layouts_title: { en: 'Layouts', de: 'Layouts' },
    howto_layout_empty: { en: '<strong>Empty:</strong> Free-form canvas', de: '<strong>Leer:</strong> Freie Fläche' },
    howto_layout_three_column: { en: '<strong>Three-Column:</strong> Three side-by-side columns', de: '<strong>Drei Spalten:</strong> Drei nebeneinanderliegende Spalten' },
    howto_layout_four_column: { en: '<strong>Four-Column:</strong> Four side-by-side columns', de: '<strong>Vier Spalten:</strong> Vier nebeneinanderliegende Spalten' },
    howto_layout_two_split: { en: '<strong>Two-Split:</strong> Left and right columns', de: '<strong>Zweifach:</strong> Linke und rechte Spalte' },
    howto_layout_three_split: { en: '<strong>Three-Split:</strong> Two top boxes and one full-width bottom box', de: '<strong>Dreifach:</strong> Zwei obere Bereiche und ein unterer Bereich über die volle Breite' },
    howto_layout_four_split: { en: '<strong>Four-Split:</strong> Four quadrants', de: '<strong>Vierfach:</strong> Vier Bereiche' },
    howto_layout_kanban: { en: '<strong>Kanban:</strong> Multiple columns for workflow', de: '<strong>Kanban:</strong> Mehrere Spalten für den Ablauf' },
    howto_layout_weekday: { en: '<strong>Weekday:</strong> Seven columns for days of the week', de: '<strong>Wochentag:</strong> Spalten für die Wochentage' },

    howto_general_title: { en: 'General', de: 'Allgemein' },
    howto_general_import: {
        en: '<strong>Import/Export:</strong> Use menu to import or export your data',
        de: '<strong>Import/Export:</strong> Menü zum Importieren oder Exportieren nutzen'
    },
    howto_general_theme: {
        en: '<strong>Theme:</strong> Switch between light, dark, or system mode in the menu',
        de: '<strong>Design:</strong> Zwischen hell, dunkel oder Systemmodus im Menü wechseln'
    },
    howto_general_recycle: {
        en: '<strong>Recycle Bin:</strong> Last tab - double-click tab to empty all notes, double-click a note to permanently delete it. Configure auto-delete in App Settings',
        de: '<strong>Papierkorb:</strong> Letzter Tab - Doppelklick auf Tab leert alle Notizen, Doppelklick auf eine Notiz löscht sie permanent. Auto-Löschen in den App-Einstellungen einstellen'
    },

    tab_settings_title: { en: 'Tab Settings', de: 'Tab-Einstellungen' },
    tab_delete_tab: { en: 'Delete Tab', de: 'Tab löschen' },
    tab_name_label: { en: 'Tab Name', de: 'Tab-Name' },
    tab_name_placeholder: { en: 'Tab name', de: 'Tab-Name' },
    tab_color_label: { en: 'Tab Color', de: 'Tab-Farbe' },
    tab_layout_label: { en: 'Layout', de: 'Layout' },
    tab_box_settings: { en: 'Box Settings', de: 'Box-Einstellungen' },
    tab_box_name_placeholder: { en: 'Box name', de: 'Box-Name' },
    tab_change_color: { en: 'Change color', de: 'Farbe ändern' },
    tab_new_title: { en: 'New tab', de: 'Neuer Tab' },
    tab_welcome_name: { en: 'Welcome', de: 'Willkommen' },

    layout_option_empty: { en: 'Empty', de: 'Leer' },
    layout_option_three_column: { en: 'Three-Column', de: 'Drei Spalten' },
    layout_option_four_column: { en: 'Four-Column', de: 'Vier Spalten' },
    layout_option_two_split: { en: 'Two-Split', de: 'Zweifach' },
    layout_option_three_split: { en: 'Three-Split', de: 'Dreifach' },
    layout_option_four_split: { en: 'Four-Split', de: 'Vierfach' },
    layout_option_kanban: { en: 'Kanban', de: 'Kanban' },
    layout_option_weekday: { en: 'Weekday', de: 'Wochentag' },
    layout_box_left: { en: 'Left', de: 'Links' },
    layout_box_center: { en: 'Center', de: 'Mitte' },
    layout_box_right: { en: 'Right', de: 'Rechts' },
    layout_box_column_1: { en: 'Column 1', de: 'Spalte 1' },
    layout_box_column_2: { en: 'Column 2', de: 'Spalte 2' },
    layout_box_column_3: { en: 'Column 3', de: 'Spalte 3' },
    layout_box_column_4: { en: 'Column 4', de: 'Spalte 4' },
    layout_box_top_left: { en: 'Top Left', de: 'Oben links' },
    layout_box_top_right: { en: 'Top Right', de: 'Oben rechts' },
    layout_box_bottom: { en: 'Bottom', de: 'Unten' },
    layout_box_bottom_left: { en: 'Bottom Left', de: 'Unten links' },
    layout_box_bottom_right: { en: 'Bottom Right', de: 'Unten rechts' },
    layout_box_backlog: { en: 'Backlog', de: 'Backlog' },
    layout_box_todo: { en: 'To Do', de: 'Zu tun' },
    layout_box_in_progress: { en: 'In Progress', de: 'In Arbeit' },
    layout_box_done: { en: 'Done', de: 'Erledigt' },
    layout_box_monday: { en: 'Monday', de: 'Montag' },
    layout_box_tuesday: { en: 'Tuesday', de: 'Dienstag' },
    layout_box_wednesday: { en: 'Wednesday', de: 'Mittwoch' },
    layout_box_thursday: { en: 'Thursday', de: 'Donnerstag' },
    layout_box_friday: { en: 'Friday', de: 'Freitag' },
    layout_box_saturday: { en: 'Saturday', de: 'Samstag' },
    layout_box_sunday: { en: 'Sunday', de: 'Sonntag' },

    app_settings_title: { en: 'App Settings', de: 'App-Einstellungen' },
    recycle_bin_title: { en: 'Recycle Bin', de: 'Papierkorb' },
    app_instant_delete: { en: 'Instant Delete (skip recycle bin)', de: 'Sofort löschen (Papierkorb überspringen)' },
    app_auto_delete: { en: 'Auto-delete recycled notes', de: 'Notizen im Papierkorb automatisch löschen' },
    app_auto_delete_days: { en: 'Auto-delete after (days)', de: 'Auto-löschen nach (Tagen)' },

    common_save: { en: 'Save', de: 'Speichern' },
    common_cancel: { en: 'Cancel', de: 'Abbrechen' },

    confirm_default_title: { en: 'Confirm', de: 'Bestätigen' },
    confirm_yes_delete: { en: 'Yes, Delete', de: 'Ja, löschen' },
    confirm_delete_permanent_title: { en: 'Delete permanently?', de: 'Permanent löschen?' },
    confirm_delete_single_message: { en: 'This note will be permanently deleted.', de: 'Diese Notiz wird permanent gelöscht.' },
    confirm_delete_multi_message: { en: 'Delete {count} note(s) permanently?', de: '{count} Notiz(en) permanent löschen?' },
    confirm_move_recycle_title: { en: 'Move to Recycle Bin?', de: 'In den Papierkorb verschieben?' },
    confirm_move_recycle_message: { en: 'Move this note to the recycle bin?', de: 'Diese Notiz in den Papierkorb verschieben?' },
    confirm_empty_recycle_title: { en: 'Empty Recycle Bin', de: 'Papierkorb leeren' },
    confirm_empty_recycle_message: { en: 'Permanently delete all {count} note(s) in the recycle bin?', de: 'Alle {count} Notiz(en) im Papierkorb permanent löschen?' },
    confirm_delete_all_title: { en: 'Delete all notes?', de: 'Alle Notizen löschen?' },
    confirm_delete_all_message: {
        en: 'This will permanently delete every note on every tab, including the recycle bin.',
        de: 'Alle Notizen auf allen Tabs, inklusive Papierkorb, werden permanent gelöscht.'
    },
    confirm_reset_title: { en: 'Reset App?', de: 'App zurücksetzen?' },
    confirm_reset_message: {
        en: 'This will reset all settings and permanently delete all notes on every tab.',
        de: 'Alle Einstellungen werden zurückgesetzt und alle Notizen auf allen Tabs permanent gelöscht.'
    },
    confirm_delete_tab_title: { en: 'Delete Tab?', de: 'Tab löschen?' },
    confirm_delete_tab_instant_message: {
        en: 'This tab and all {count} note(s) on it will be permanently deleted.',
        de: 'Dieser Tab und alle {count} Notiz(en) darauf werden permanent gelöscht.'
    },
    confirm_delete_tab_recycle_message: {
        en: 'This tab will be deleted. {count} note(s) will be moved to the recycle bin.',
        de: 'Dieser Tab wird gelöscht. {count} Notiz(en) werden in den Papierkorb verschoben.'
    },

    notification_settings_saved: { en: 'Settings saved', de: 'Einstellungen gespeichert' },
    notification_recycle_emptied: { en: 'Recycle bin emptied', de: 'Papierkorb geleert' },
    notification_no_notes_delete: { en: 'No notes to delete', de: 'Keine Notizen zum Löschen' },
    notification_all_notes_deleted: { en: 'All notes deleted', de: 'Alle Notizen gelöscht' },
    notification_exported: { en: 'Data exported', de: 'Daten exportiert' },
    notification_import_success: { en: 'Data imported successfully', de: 'Daten erfolgreich importiert' },
    notification_import_error: { en: 'File is corrupted and cannot be imported', de: 'Datei ist beschädigt und kann nicht importiert werden' },
    notification_tab_deleted: { en: 'Tab deleted', de: 'Tab gelöscht' },

    note_delete_button_title: { en: 'Delete note', de: 'Notiz löschen' },

    welcome_note_storage: {
        en: 'All data is stored only in your browser (localStorage). It is not saved on a server. Do not use this for important notes - clearing your browser data will delete everything!',
        de: 'Alle Daten werden nur in deinem Browser (localStorage) gespeichert. Sie werden nicht auf einem Server gespeichert. Nutze diese App nicht für wichtige Notizen - das Löschen deiner Browserdaten löscht alles!'
    },
    welcome_note_edit: {
        en: 'Double-click (or double-tap) a note to edit it. You can change its color at the bottom.',
        de: 'Doppelklick (oder doppelt antippen) auf eine Notiz zum Bearbeiten. Die Farbe kannst du unten ändern.'
    },
    welcome_note_drag: {
        en: 'Drag notes to move them around. Drag onto the recycle bin tab to delete.',
        de: 'Ziehe Notizen, um sie zu verschieben. Ziehe sie auf den Papierkorb-Tab zum Löschen.'
    },
    welcome_note_create: {
        en: 'Right-click (or double-tap) on the canvas to create a new note.',
        de: 'Rechtsklick (oder doppelt antippen) auf die Fläche, um eine neue Notiz zu erstellen.'
    },
    welcome_note_tab_settings: {
        en: 'Double-click (or double-tap) a tab to change its name, color, or layout. Use the menu for more options.',
        de: 'Doppelklick (oder doppelt antippen) auf einen Tab, um Name, Farbe oder Layout zu ändern. Im Menü gibt es weitere Optionen.'
    }
};
